import React, { useEffect, useState } from 'react';
import { Descriptions } from 'antd';
import strings from '../../utils/strings';
import { useReportsStore } from '../../store/slices/createReportsSlice';
import { usePersistedStore } from '../../store/persisted-store';

export default function SalesTotal() {
    const reports = useReportsStore()
    const { auth } = usePersistedStore()
    const data = reports.sales.data.SummaryReport;
    // const loading = reports.sales.loading;
    const sales = reports.sales.data.DetailReport;

    const userInfo = auth.userInfo;
    const reportData = reports.sales.data.DetailReport;
    const [zeroWageAmountCount, setZeroWageAmountCount] = useState(0);

    useEffect(() => {
        if (reportData?.length) {
            let count = 0;
            reportData.map((report, index) => {
                if (report?.BusinessWageAmount == 0 || !report?.BusinessWageAmount)
                    count++
            })
            setZeroWageAmountCount(count)
        }
    }, [reportData]);

    let userResources;
    if (userInfo) {
        userResources = userInfo.Resources
    }

    let totalDebtorAmount = 0;
    sales && sales.forEach(element => {
        if (element.Installment)
            totalDebtorAmount += (element.Premium - element.VoucherAmount - element.Payment);
    });
    let totalPenalty = 0;
    sales && sales.forEach(element => {
        totalPenalty += (element.Penalty);
    });

    let totalConflictNegative = 0;
    let sumNegative = 0;
    sales && sales.forEach(element => {
        if (!element.Installment) {
            sumNegative = (element.Premium - element.Payment - element.VoucherAmount - element.NotSendDiscount);
            if (sumNegative < 0)
                totalConflictNegative += (sumNegative);
        }
    });


    let totalConflictPositive = 0;
    let sumPositive = 0;
    sales && sales.forEach(element => {
        if (!element.Installment) {
            sumPositive = (element.Premium - element.Payment - element.VoucherAmount - element.NotSendDiscount);
            if (sumPositive > 0)
                totalConflictPositive += (sumPositive);
        }
    });

    if (!data) {
        return <div></div>
    }
    return (
        <div style={{ marginTop: "10px" }} >
            <Descriptions column={3} bordered size="small">
                <Descriptions.Item label="بیمه نامه صادر شده">{strings.getFarsiNum(data.PayCount)}&nbsp;</Descriptions.Item>
                <Descriptions.Item label="جمع حق بیمه">{strings.currencyFormat(data.TotalPremium)}&nbsp;ریال</Descriptions.Item>
                <Descriptions.Item label="جمع مبلغ پرداختی">{strings.currencyFormat(data.TotalPayment)}&nbsp;ریال</Descriptions.Item>
                <Descriptions.Item label="جمع کارمزد">{strings.currencyFormat(data.TotalBusinessWageAmount)}&nbsp;ریال</Descriptions.Item>
                <Descriptions.Item label="مبلغ کارمزد با مالیات">{strings.currencyFormat(data.BusinessAmountWithTax)}&nbsp;ریال</Descriptions.Item>
                <Descriptions.Item label="مبلغ کل کد تخفیف">{strings.currencyFormat(data.TotalVocherAmount)}&nbsp;ریال</Descriptions.Item>
                <Descriptions.Item label="مبلغ کل مالیات">{strings.currencyFormat(data.TotalTaxAmount)}&nbsp;ریال</Descriptions.Item>
                <Descriptions.Item label="جمع مانده بدهکار ">{strings.currencyFormat(totalDebtorAmount)}&nbsp;ریال</Descriptions.Item>
                <Descriptions.Item label="جمع جرایم">{strings.currencyFormat(totalPenalty)}&nbsp;ریال</Descriptions.Item>
                <Descriptions.Item label="جمع تخفیف عدم ارسال">{strings.currencyFormat(data.TotalNotSendDiscountAmount)}&nbsp;ریال</Descriptions.Item>
                <Descriptions.Item label="جمع تخفیف عدم بازدید">{strings.currencyFormat(data.TotalNotVisitDiscountAmount)}&nbsp;ریال</Descriptions.Item>
                <Descriptions.Item label="جمع مغایرت (عودت) ">{strings.currencyFormat(totalConflictNegative)}&nbsp;ریال</Descriptions.Item>
                <Descriptions.Item label="جمع مغایرت (تخفیف)">{strings.currencyFormat(totalConflictPositive)}&nbsp;ریال</Descriptions.Item>
                <Descriptions.Item label="جمع سایر تخفیف ها">{strings.currencyFormat(data.TotalOtherDiscountsAmount)}&nbsp;ریال</Descriptions.Item>

                {userResources && userResources.includes('BusinessesManagment') && <Descriptions.Item className="zeroWageAmountCount" label="تعداد موارد بدون کارمزد">{zeroWageAmountCount ? zeroWageAmountCount : 0}</Descriptions.Item>}
                <Descriptions.Item label="جمع مبلغ کارت به کارت">{strings.currencyFormat(data.TotalCartToCartAmount)}&nbsp;ریال</Descriptions.Item>
            </Descriptions>
        </div>
    );
}



